import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  Contabilidad
} from '@p-p-portafolio/promociones/interfaces/contabilidad';
import { OpcionesService } from '@p-p-portafolio/services/opciones.service';
import { ContabilidadPromocionComponent } from '@p-p-portafolio/promociones/contabilidad-promocion/contabilidad-promocion.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SwalService } from '@shared/utils/swal.service';
import { Opciones } from '@p-p-portafolio/interfaces/opciones';
import { OpcionesRequest } from '@shared/interfaces/request/opciones';
import { ProductoRangos } from '@p-parametria/mantenimiento/abc-empresas/interfaces/productoRangos';
import { ProductoRangosService } from '@pages/tipos-credito/services/producto-rangos.service';
import { ProductosService } from '@pages/tipos-credito/services/productos.service';

@Component({
  selector: 'app-productos-form',
  templateUrl: './productos-form.component.html',
  styleUrls: ['./productos-form.component.css'],
})
export class ProductosFormComponent implements OnInit {
  productos: Opciones[] = [];
  opcionesRequestModel: OpcionesRequest;
  public loading: boolean;
  public promocion: string = localStorage.getItem('prom');
  constructor(
    private _perfilService: ProductosService,
    private fb: UntypedFormBuilder,
    private _dialogRef: MatDialogRef<ContabilidadPromocionComponent>,
    private _swalService: SwalService,
    private _productosService : ProductoRangosService,
    @Inject(MAT_DIALOG_DATA) public model: ProductoRangos
  ) {
    if (this.model !== null) {
      const setModel = {
        clavePerfil: model.clavePerfil,
        variable: model.variable,
        rango: model.rango,
        paquete: model.paquete,
        producto: model.producto,
        porcentaje: model.porcentaje,
        plazoMin: model.plazoMin,
        plazoMax: model.plazoMax,
        tasaMin: model.tasaMin,
        tasaMax: model.tasaMax,
        porcCredito: model.porcCredito,
        lineaMin: model.lineaMin,
        lineaMax: model.lineaMax,
      };
      this.form.setValue(setModel);
    }
  }
  form = this.fb.group({
    clavePerfil: [''],
    variable: [''],
    rango: [''],
    paquete: [''],
    producto: [''],
    porcentaje: [''],
    plazoMin: [''],
    plazoMax: [''],
    tasaMin: [''],
    tasaMax: [''],
    porcCredito: [''],
    lineaMin: [''],
    lineaMax: [''],
  });

  ngOnInit(): void {
    this.cargarProductos();
  }

  cargarProductos() {
    this._perfilService.read().subscribe((res) => {
      this.productos = res.data;
    });
  }

  mapForm() {
    const item: ProductoRangos = {
      clavePerfil: this.form.value.clavePerfil,
      variable: this.form.value.variable,
      rango: this.form.value.rango,
      paquete: this.form.value.paquete,
      producto: this.form.value.producto,
      porcentaje: this.form.value.porcentaje,
      plazoMin: this.form.value.plazoMin,
      plazoMax: this.form.value.plazoMax,
      tasaMin: this.form.value.tasaMin,
      tasaMax: this.form.value.tasaMax,
      porcCredito: this.form.value.porcCredito,
      lineaMin: this.form.value.lineaMin,
      lineaMax: this.form.value.lineaMax
    };
    return item;
  }

  agregar(model: Contabilidad) {
    this._productosService.create(this.mapForm()).subscribe((res) => {
      this.loading = false;
      if (res != null) {
        this._dialogRef.close();
        this._swalService.success('Agregado');
      } else this._swalService.error('No Agregado');
    });
  }

  update(model: ProductoRangos) {
    this._productosService.update(this.mapForm()).subscribe((res) => {
      this.loading = false;
      if (res != null) {
        this._dialogRef.close();
        this._swalService.success('Actualizado');
      } else this._swalService.error('No Actualizado');
    });
  }

  close() {
    this._dialogRef.close();
  }
}
